<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
      @batchDel="submitDel"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        :changeOrderCode="changeOrderCode"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
        @batchDel="batchDel"
      />
      <pagination
        size="mini"
        align="right"
        slot="pager"
        :layouts="[
          'Total',
          'Sizes',
          'PrevJump',
          'PrevPage',
          'NextPage',
          'NextJump',
          'FullJump',
        ]"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="1000px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <demand-table-edit-form
        ref="editForm"
        :addType="editFormDialogOptions.type"
        :code="editFormDialogOptions.code"
        :changeOrderCode="editFormDialogOptions.changeOrderCode"
        :disabled="editFormDialogOptions.disabled"
        :params="editFormDialogOptions.params"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
import DemandTableEditForm from '../demand-table-edit-form/index.vue'

export default {
  props: {
    changeOrderCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PageMain,
    PageHeader,
    DemandTableEditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {},
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .changeOrderDemandFabricListApi({
          changeOrderCode: this.changeOrderCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        batchAdd:
          this.$l('INDEX.order_dialog_title_order_demand_fabric_add') || '添加订单面料需求',
        add:
          this.$l('INDEX.order_dialog_title_order_demand_fabric_add') || '添加订单面料需求',
        edit:
          this.$l('INDEX.order_dialog_title_order_demand_fabric_edit') ||
          '编辑订单面料需求',
        detail:
          this.$l('INDEX.order_dialog_title_order_demand_fabric_detail') ||
          '订单面料需求详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        code: params.changeOrderFabricCode,
        disabled: type === 'detail',
        changeOrderCode: this.changeOrderCode,
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    //批量删除的操作
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api
            .changeOrderDemandFabricDelApi({ changeOrderFabricCodeList: listCode })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                type: 'success',
              })
              this.$refs.header.query()
            })
        })
        .catch(() => {})
    },
  },
}
</script>
